export const useGetNextPaymentDateTranslationKeys = {
  paymentRegularNextPayment: 'payment.regular-next-payment',
  paymentsInProgress: 'payments.in-progress',

  paymentsNextPayment: 'payments.next-payment',
}
